/** THE TOP BAR'S SEARCH, ONE RULE (ported 2026-10-18 from the medrec console's lib/list-search.ts, its redesign follow-ups, PR #166;
 *  DESIGN_SYSTEM 6: search in every page's top bar). The typed words, any case, each one somewhere in the row's words (a part of a word
 *  counts), the row's order kept. A row's words are the texts its cells show; numbers are never searched (a count of 41 is no answer to
 *  "41"). In core because All unopened searches on the server, over the whole list before the page (unopened.ts); every other list keeps
 *  its rows in the page (web list/list-search.ts). Pure. It replaced each page's own rule, which matched the whole typed phrase as one
 *  piece ("progressive john" found nothing where "John ... Progressive" was on the row). */
/** The typed words: split on white space, lower case; nothing typed is no words. */
export const searchWordsOf = (q) => String(q ?? '').trim().toLowerCase().split(/\s+/).filter((w) => w !== '');
/** Whether every word is in the row's words (its texts joined; a number, a null and nothing are skipped). No words always match. */
export function matchesWords(fields, words) {
    if (words.length === 0)
        return true;
    const hay = fields.filter((f) => typeof f === 'string').join(' \u{2002} ').toLowerCase();
    return words.every((w) => hay.includes(w));
}
export const SEARCH_WORDS = Object.freeze({
    /** A list the search emptied (DESIGN_SYSTEM 12, "No match": say so, and the next step). The medrec console's words. */
    none: (q) => `Nothing on this page matches \u{201C}${q.trim()}\u{201D}. Clear the search to see every row.`,
});
//# sourceMappingURL=list_search.js.map